import { useEffect } from 'react';
import { useMainSelector } from '../useMainSelector';
import { useCannedResponsesActions } from './useCannedResponsesActions';

export const useCannedResponsesEvents = () => {
  const {
    chat: { isCannedResponsesMenuOpen },
  } = useMainSelector();

  const { getCannedResponses, removeCannedResponses } = useCannedResponsesActions();

  useEffect(() => {
    if (isCannedResponsesMenuOpen) {
      getCannedResponses();
    } else {
      removeCannedResponses();
    }
  }, [isCannedResponsesMenuOpen, getCannedResponses, removeCannedResponses]);
};
